export const lawyers = [
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Петро Щур',
    address: 'Dnipro Central str.',
    age: 33,
    count: 22,
    exp: 5,
    stream: 'Сімейні справи',
    tel: '+2641612625645',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Іван Іванов',
    address: 'Kyiv Main ave.',
    age: 40,
    count: 15,
    exp: 10,
    stream: 'Кримінальні справи',
    tel: '+380661234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Марія Коваль',
    address: 'Lviv City center',
    age: 29,
    count: 10,
    exp: 4,
    stream: 'Трудові справи',
    tel: '+380671234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Олег Петров',
    address: 'Odesa Sea view',
    age: 45,
    count: 30,
    exp: 20,
    stream: 'Міжнародні справи',
    tel: '+380501234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Анна Мельник',
    address: 'Kharkiv Park lane',
    age: 36,
    count: 18,
    exp: 12,
    stream: 'Комерційні справи',
    tel: '+380631234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Дмитро Орлов',
    address: 'Vinnytsia Lake road',
    age: 38,
    count: 21,
    exp: 14,
    stream: 'Екологічні справи',
    tel: '+380661234568',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Тетяна Іванова',
    address: 'Zaporozhye Central park',
    age: 32,
    count: 17,
    exp: 8,
    stream: 'Конституційні справи',
    tel: '+380991234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Василь Бойко',
    address: 'Uzhhorod River side',
    age: 41,
    count: 25,
    exp: 15,
    stream: 'Кримінальні справи',
    tel: '+380501234568',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Олена Гончар',
    address: 'Cherkasy Hill top',
    age: 30,
    count: 12,
    exp: 7,
    stream: 'Сімейні справи',
    tel: '+380931234567',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Богдан Мороз',
    address: 'Poltava Freedom st.',
    age: 34,
    count: 19,
    exp: 10,
    stream: 'Земельні справи',
    tel: '+380671234568',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Катерина Олійник',
    address: 'Rivne Green valley',
    age: 37,
    count: 20,
    exp: 11,
    stream: 'Фінансові справи',
    tel: '+380991234568',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Віктор Соколов',
    address: 'Zhytomyr Old town',
    age: 42,
    count: 28,
    exp: 16,
    stream: 'Цивільні справи',
    tel: '+380501234569',
  },
  {
    img: 'https://www.deadlawyers.org/wp-content/uploads/2022/05/c2f3177ed47bd7343dc7181afba25cdd5d1ec.jpg',
    username: 'Наталія Бондаренко',
    address: 'Chernihiv New district',
    age: 35,
    count: 22,
    exp: 12,
    stream: 'Медичне право',
    tel: '+380671234569',
  },
];
